// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MDrw","col":"styles_col__3isEH"};